__turbopack_context__.v({
  "heroCta": "ftrB2W_heroCta",
});
